<template>
  <div class="w-full flex items-center justify-between gap-2 mb-4 md:mb-2">
    <!-- Left side content -->
    <div class="flex items-center gap-2 min-w-0 flex-1">
      <VaIcon
        v-if="props.showBackButton"
        name="arrow_back"
        class="cursor-pointer flex-shrink-0"
        size="large"
        @click="router.back()"
      />
      <div class="flex items-baseline gap-2 min-w-0">
        <h1 class="title truncate">{{ props.title }}</h1>
        <h3 v-if="props.subtitle" class="subtitle truncate">
          {{ props.subtitle }}
        </h3>
      </div>
      <slot name="title-actions" />
    </div>

    <!-- Right side buttons -->
    <div class="flex gap-2 flex-shrink-0">
      <slot name="buttons" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, watchEffect } from "vue";
import { useRouter } from "vue-router";
import { usePageTitlePresence } from "../../composables/usePageTitlePresence";

const router = useRouter();

const props = defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: null },
  showBackButton: { type: Boolean, default: true },
});

const { register, unregister } = usePageTitlePresence();
onMounted(register);
onBeforeUnmount(unregister);

watchEffect(() => {
  const divider = props.subtitle ? " | " : "";
  window.document.title = `JTP - ${props.title}${divider}${props.subtitle}`;
});
</script>

<style scoped>
.title {
  @apply text-[32px] md:text-4xl font-bold leading-9 md:leading-[56px] max-sm:mt-6;
}

.subtitle {
  @apply text-2xl leading-[30px];
}
</style>
